module.exports = __webpack_public_path__ + "img/new-project.153f47c9.svg";